thresholdSettings.classy.controller({
    name: 'ApplyModalController',
    inject: ['$scope', 'DateService', '$modalInstance'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.currentYear = this.DateService.getCurrentYear();
    },
    secondChance: function()
    {
        var parent = this;
        swal({
                title: "Warning!!",
                text: "Please Read!!! This change can have a major impact on work that has already been done. We ask that you reconfirm that you would like to take this action. This process can not be undone. If you do not wish to make this change to all applications go back and make sure 'Apply to all "+this.$.currentYear+"-"+(this.$.currentYear+1)+" applications' is unchecked.",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD68BB",
                cancelButtonText: "Go Back",
                confirmButtonText: "I have read the warnings and wish to make this change",
                closeOnConfirm: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    parent.$.$modalInstance.close();
                }
                else {
                    parent.$.$modalInstance.dismiss('cancel')
                }
            });
    }
});